export default "/images/vendor/flag-icon-css/flags/4x3/me.svg?0b785614513a0b99de04a91166cbf603";